// extracted by mini-css-extract-plugin
export default {"container":"AuthLayout_container__Z2jRR"};